
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, switchMap, filter, take, of, tap, catchError, throwError, takeLast } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { SearchDomainTypeParam } from '../models/SearchDomainTypeParam';
import { CommonParam } from '../models/CommonParam';
import { CacheType } from './cpstorage.service';
import { CacheRequestOptions } from './interceptors/caching-interceptor';
import { environment } from '@env/environment';
import { CommonValues } from '../static/CommonValues';

@Injectable()
export class SearchService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Search/";
        this.baseUrl_v2 = this.rootUrl_v2 + "Search/";
    }
    private getSearchTypesSubjectMap = new Map<string, BehaviorSubject<any>>();

    getSearchTypes(code: string = null): Observable<any> {
        let url_call: string = this.baseUrl + "GetSearchTypes/" + code;

        let gettingSearchTypeInProgress = this.getSearchTypesSubjectMap.get(url_call);
        // gettingSearchTypeInProgress.isStopped has to be used cause of the old version we are on. closed is not populated properly
        if (gettingSearchTypeInProgress && !gettingSearchTypeInProgress.closed && !gettingSearchTypeInProgress.isStopped) {
            if (environment.debug) {
                console.debug("%c GetSearchTypes: Returning fetchResultSubject due to fetch in progress.", CommonValues.LoggingMessage_ColorLightGreen, url_call);
            }
            return gettingSearchTypeInProgress.pipe(
                filter(result => result !== "searching"),
                takeLast(1)
            );
        }

        this.getSearchTypesSubjectMap.set(url_call, new BehaviorSubject<any>("searching"));
        let headers = this.getHeaders();
        let ctx = super.createCacheContext(new CacheRequestOptions(240, CacheType.Session));// 4 minutes
        return this._http.get(url_call, { headers: headers, context: ctx }).pipe(
            tap((data: any) => {
                let subject = this.getSearchTypesSubjectMap.get(url_call);
                if (subject) {
                    subject.next(data);
                    subject.complete();
                    this.getSearchTypesSubjectMap.set(url_call, subject);
                }
            }),
            catchError((error) => {
                let subject = this.getSearchTypesSubjectMap.get(url_call);
                if (subject) {
                    subject.error(error);
                    subject.complete();
                    this.getSearchTypesSubjectMap.set(url_call, subject);
                }
                return throwError(() => error);
            })
        );
    }
    getCPSearch(param: CommonParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "CommonParam", s_param);
        let url_call: string = this.baseUrl + "GetCPSearch";
        return this._http.get(url_call, options);
    }

    getEmployeeSearch(param: CommonParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let url_call: string = this.baseUrl_v2 + "employee";
        return super.post(url_call, s_param);
    }

    getCPSearchTest(commonParam: any): Observable<any> {
        let s_commonParam: string = JSON.stringify(commonParam);
        let options = this.getOptionsU('', "CommonParam", s_commonParam);
        let url_call: string = this.baseUrl + "GetCPSearchTest";
        return this._http.get(url_call, options);
    }

    getCPSearchDomain(param: SearchDomainTypeParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "SearchDomainTypeParam", s_param);
        let url_call: string = this.baseUrl + "GetCPSearchDomain";
        return this._http.get(url_call, options);
    }

}
